/* eslint-disable react/no-array-index-key */
import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Grid, Box, Link, Typography, ButtonBase } from '@material-ui/core'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import {
  TabPanel,
  a11yProps,
} from '../../DashboardComponents/TabPanel/TabPanel'
import Widget, { SmallIconLink } from '../Widget'
import SearchBar from '../../DashboardComponents/SearchBar/SearchBar'
import Footer from '../../DashboardComponents/Footer/Footer'
import { logDashboardEvent } from '../../events'

import {
  fetchIPOAnnouncements,
  fetchIPOCases,
  updateQuery,
  updateTabValue,
  updateTabValue2,
} from './IPOServiceCenterSlice'
import Loading from '../helpers/Loading'
import {
  RutgersTab,
  RutgersTabs,
} from '../../DashboardComponents/Tabs/RutgersTabs'
import CaseIndicator from '../../DashboardComponents/CaseIndicator/CaseIndicator'
import { ErrorMessage } from '../../DashboardComponents/ErrorMessages/ErrorMsg'
import { useTabTracking } from '../../../../helpers/useTabTracking'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'
import Announcement from '../RUDOTSServiceCenter/Announcement'
import MyCasesObject from '../RUDOTSServiceCenter/MyCasesObject'
import { IPOServiceCenterStyles } from './ipoServiceCenterStyles'

/**
 * IPO Service Widget
 * Shows announcements and cases for the account as well as redirect links
 * @param {*} param0
 * @returns
 */
// eslint-disable-next-line no-unused-vars
export default function IPOServiceCenter({ className, title, widgetId }) {
  const classes = IPOServiceCenterStyles()
  const dispatch = useDispatch()
  const widgetData = useSelector((s) => s.IPOServiceCenter)

  const { announcements, status } = widgetData
  React.useEffect(() => {
    dispatch(fetchIPOAnnouncements())
    dispatch(fetchIPOCases('Open'))
  }, [])
  return (
    <Widget className={className}>
      <Widget.Header title={title} />
      <Widget.Content className={classes.content}>
        {renderIPOServiceState(announcements, status, widgetId)}
      </Widget.Content>
    </Widget>
  )
}

function renderIPOServiceState(announcements, status, widgetId) {
  switch (status) {
    case 'fulfilled':
      return <Loaded announcements={announcements} widgetId={widgetId} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}
function renderOpenCaseState(caseStatus, widgetId, dispatch) {
  switch (caseStatus) {
    case 'fulfilled':
      return <MyOpenCases widgetId={widgetId} dispatch={dispatch} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}
function renderClosedCaseState(caseStatus, widgetId, dispatch) {
  switch (caseStatus) {
    case 'fulfilled':
      return <MyClosedCases widgetId={widgetId} dispatch={dispatch} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}

function Loaded(props) {
  const { announcements, widgetId } = props
  const classes = IPOServiceCenterStyles()
  const dispatch = useDispatch()
  const trackTabChange = useTabTracking(
    dispatch,
    'IPOServiceCenter',
    ['Announcements', 'My Cases'],
    { widgetId },
  )
  const trackSubTabChange = useTabTracking(
    dispatch,
    'IPOServiceCenter',
    ['Open', 'Closed'],
    { widgetId },
  )
  const handleChange = (event, newValue) => {
    trackTabChange(event, newValue, () => dispatch(updateTabValue(newValue)))
  }
  const handleChange2 = (event, newValue2) => {
    trackSubTabChange(event, newValue2, () => {
      dispatch(updateTabValue2(newValue2))
      dispatch(fetchIPOCases(newValue2 === 1 ? 'Closed' : 'Open'))
    })
  }

  const { myCasesOpen, value, value2, query, caseStatus } = useSelector(
    (s) => s.IPOServiceCenter,
  )

  React.useEffect(() => {
    if (value === 1) {
      dispatch(fetchIPOCases('Open'))
    }
  }, [value])

  const searchOnRequest = (val) => {
    // Spaces are replaced by '%20' in the search link
    const redirectString = encodeURIComponent(
      val.toString().split(' ').join('%20'),
    )
    const link = `${process.env.REACT_APP_IPOSERVICE_BASE_URL}/ipo_help?id=search&spa=1&q=${redirectString}`

    trackWidgetClick(dispatch, 'IPOServiceCenter', 'Search', { widgetId })
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        redirectString,
        link,
      )
    }
    // Opens new tab with search bar value
    window.open(link, '_blank')
  }

  const footerButtonTitle = 'Launch IPO Service Center'
  const footerLink = `${process.env.REACT_APP_IPOSERVICE_BASE_URL}/ipo_help`
  const handleFooterLinkClick = () => {
    trackWidgetClick(dispatch, 'IPOServiceCenter', footerButtonTitle, {
      widgetId,
    })
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        footerButtonTitle,
        footerLink,
      )
    }
  }

  const handleHeaderLinkClick = () => {
    trackWidgetClick(dispatch, 'IPOServiceCenter', 'IPO Help', { widgetId })
    // Opens new tab with search bar value
    window.open(footerLink, '_blank')
  }
  return (
    <Grid
      container
      direction="column"
      className={classes.mainGrid}
      wrap="nowrap"
    >
      <Grid container direction="column" wrap="nowrap">
        <Grid item className={classes.imgContainer} container direction="row">
          <ButtonBase onClick={handleHeaderLinkClick}>
            <Typography className={classes.headerText}>IPO Help</Typography>
          </ButtonBase>
        </Grid>

        <Grid item className={classes.searchBar}>
          <SearchBar
            placeholder="How can we help you?"
            className={classes.searchBar}
            value={query}
            onChange={(result) => dispatch(updateQuery(result))}
            onCancelSearch={() =>
              dispatch(updateQuery({ target: { value: '' } }))
            }
            webViewMode
            onRequestSearch={() => searchOnRequest(query)}
            variant="outlined"
            moduleName={widgetId}
          />
        </Grid>
      </Grid>

      <Grid className={classes.modalTabs}>
        <RutgersTabs value={value} onChange={handleChange} aria-label="Top Tab">
          <RutgersTab label="Announcements" {...a11yProps(0)} />
          <RutgersTab
            label={
              <Box display="flex" style={{ alignItems: 'center' }}>
                <Typography className={classes.tabTextLabel}>
                  My Cases
                </Typography>
                {myCasesOpen && myCasesOpen.length > 0 && (
                  <CaseIndicator value={myCasesOpen?.length} />
                )}
              </Box>
            }
            {...a11yProps(1)}
          />
        </RutgersTabs>
      </Grid>
      {/* Announcement tab */}
      <TabPanel value={value} index={0} className={classes.tabPanel}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.announcementList}
        >
          {announcements?.results?.length === 0 ? (
            <Grid container direction="column" alignItems="center">
              <Grid item>
                <CheckCircleOutlineIcon className={classes.circleIcon} />
              </Grid>

              <Grid item>
                <Typography variant="subtitle1">
                  No Announcement Data
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {announcements?.results?.map((announcement, index) => (
                <Announcement
                  key={index}
                  announcement={announcement}
                  widgetId={widgetId}
                  dispatch={dispatch}
                />
              ))}
            </>
          )}
          {announcements?.length === 0 ? (
            <Grid container direction="column" alignItems="center">
              <Grid item>
                <CheckCircleOutlineIcon className={classes.circleIcon} />
              </Grid>

              <Grid item>
                <Typography variant="subtitle1">
                  No Announcement Data
                </Typography>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </TabPanel>

      {/* My cases tab */}
      <TabPanel value={value} index={1} className={classes.tabPanel}>
        <Box className={classes.modalTabs}>
          <RutgersTabs
            value={value2}
            onChange={handleChange2}
            aria-label="Top Tab"
            className={classes.tabBackground}
          >
            <RutgersTab label="Open" {...a11yProps(2)} />
            <RutgersTab label="Closed" {...a11yProps(3)} />
          </RutgersTabs>
        </Box>

        {/* Open tab */}
        <TabPanel value={value2} index={0} className={classes.tabPanel}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.casesList}
          >
            {renderOpenCaseState(caseStatus, widgetId, dispatch)}
          </Grid>
        </TabPanel>

        {/* Closed tab */}
        <TabPanel value={value2} index={1} className={classes.tabPanel}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.casesList}
          >
            {renderClosedCaseState(caseStatus, widgetId, dispatch)}
          </Grid>
        </TabPanel>
      </TabPanel>
      {/* Bottom container */}
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        wrap="nowrap"
        className={classes.bottomContainer}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          className={classes.grid1}
        >
          <Grid item>
            <SmallIconLink
              classes={classes}
              icon="fas fa-book"
              iconLabel={
                <Typography component="span" className={classes.tabLink}>
                  Find Answers
                </Typography>
              }
              link={`${process.env.REACT_APP_IPOSERVICE_BASE_URL}/ipo_help?id=kb_view2`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>

          <Grid item>
            <SmallIconLink
              classes={classes}
              icon="fas fa-person"
              iconLabel={
                <Typography component="span" className={classes.tabLink}>
                  Contact Service & Issues
                </Typography>
              }
              link={`${process.env.REACT_APP_IPOSERVICE_BASE_URL}/ipo_help?id=ipo_sc_category`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>

          {/* <Grid item>
            <SmallIconLink
              classes={classes}
              icon="fas fa-question"
              iconLabel={
                <Typography component="span" className={classes.tabLink}>
                  Get Help
                </Typography>
              }
              link={`${process.env.REACT_APP_IPOSERVICE_BASE_URL}/ru_dots?id=dots_get_help&sys_id=0ac4a5dbdb65fc105a54230bd3961949`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid> */}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.grid2}
        >
          <Footer toggleStroke>
            <Link
              href={footerLink}
              target="_blank"
              underline="none"
              color="primary"
              onClick={() => handleFooterLinkClick()}
              className={classes.footerLink}
            >
              <Typography variant="subtitle1" className={classes.footerText}>
                {footerButtonTitle}
              </Typography>
            </Link>
          </Footer>
        </Grid>
      </Grid>
    </Grid>
  )
}

function MyOpenCases({ widgetId, dispatch }) {
  const classes = IPOServiceCenterStyles()
  const { myCasesOpen } = useSelector((s) => s.IPOServiceCenter)
  return (
    <>
      {myCasesOpen && myCasesOpen.length === 0 ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CheckCircleOutlineIcon className={classes.circleIcon} />
          </Grid>

          <Grid item>
            <Typography variant="subtitle1">No Open Case Data</Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column">
          <>
            {myCasesOpen?.map((cases, index) => (
              <MyCasesObject
                key={index}
                cases={cases}
                widgetId={widgetId}
                dispatch={dispatch}
              />
            ))}
          </>
        </Grid>
      )}
    </>
  )
}

function MyClosedCases({ widgetId, dispatch }) {
  const classes = IPOServiceCenterStyles()
  const { myCasesClosed } = useSelector((s) => s.IPOServiceCenter)
  return (
    <>
      {myCasesClosed.length === 0 ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CheckCircleOutlineIcon className={classes.circleIcon} />
          </Grid>

          <Grid item>
            <Typography variant="subtitle1">No Closed Case Data</Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column">
          <>
            {myCasesClosed.map((cases, index) => (
              <MyCasesObject
                key={index}
                cases={cases}
                status="closed"
                widgetId={widgetId}
                dispatch={dispatch}
              />
            ))}
          </>
        </Grid>
      )}
    </>
  )
}
